<template>
  <!-- 车辆详情弹框 -->
  <a-modal
      :visible="props.visible"
      :footer="null"
      width="1100px"
      @cancel="handleCancel"
      @update:visible="(value) => emit('update:visible', value)"
  >
    <div class="personnel-detail-container">
      <div class="personnel-edit-section">
        <!-- 基本信息 -->
        <div class="personnel-edit-row">
          <div class="personnel-detail-item">
            <span class="personnel-detail-label">姓名：</span>
            <span class="personnel-detail-value">{{ personnel.personnelModel || '-' }}</span>
          </div>
          <div class="personnel-detail-item">
            <span class="personnel-detail-label">身份证号码：</span>
            <span class="personnel-detail-value">{{ personnel.personnelType || '-' }}</span>
          </div>
        </div>
        <div class="personnel-edit-row">
          <div class="personnel-detail-item">
            <span class="personnel-detail-label">联系方式：</span>
            <span class="personnel-detail-value">{{ personnel.engineNumber || '-' }}</span>
          </div>
          <div class="personnel-detail-item">
            <span class="personnel-detail-label">培训日期：</span>
            <span class="personnel-detail-value">{{ personnel.productionDate || '-' }}</span>
          </div>
        </div>
        <div class="personnel-edit-row">
          <div class="personnel-detail-item">
            <span class="personnel-detail-label">性别：</span>
            <span class="personnel-detail-value">{{ personnel.vin || '-' }}</span>
          </div>
        </div>
      </div>

    </div>
  </a-modal>
</template>

<script setup name="PersonnelDetailModal">
import { defineProps, defineEmits, computed } from 'vue';
import useAppStore from "@/store/modules/app";

const appStore = useAppStore();

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  personnel: {
    type: Object,
    default: () => ({})
  },
  deptName: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:visible']);

// 处理取消事件
const handleCancel = () => {
  emit('update:visible', false);
};

// 从store中获取系统字典列表
const sysDictVOList = computed(() => appStore.SysDictVOList);
</script>

<style scoped>
.personnel-detail-container {
  padding: 0 20px;
}

.personnel-edit-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.personnel-edit-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.personnel-edit-row {
  display: flex;
  margin-bottom: 16px;
  padding-left: 40px;
  padding-right: 40px;
  gap: 16px;
}

.personnel-detail-item {
  display: flex;
  align-items: center;
  flex: 1;
}

.personnel-detail-label {
  font-weight: 500;
  color: #666;
  min-width: 100px;
}

.personnel-detail-value {
  color: #333;
}
</style>